// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"6a968824","453":"2f4bb558"}[chunkId] + ".chunk.js";
};